import React, { PureComponent } from 'react';

import PageBottomBar from './PageBottomBar';
import { hasBarContentChanged } from './utils';

const withPageBottomBarControl = (PageComponent) =>
    class AddPageBottomWrapper extends PureComponent {
        constructor(props) {
            super(props);
            const { hasBottomBarActive } = props;

            this.state = {
                hasInitialized: hasBottomBarActive,
                pageBottomBarOptions: undefined,
                hasBottomBarActive,
            };
        }

        static defaultProps = {
            hasBottomBarActive: false,
        };

        _showPageBottomBar = (options = {}) => {
            const {
                hasInitialized,
                hasBottomBarActive,
                pageBottomBarOptions: { barContent = {}, isShown = false } = {},
            } = this.state;
            if (
                hasBarContentChanged(
                    barContent?.props,
                    options?.barContent?.props,
                ) ||
                !isShown
            ) {
                this.setState({
                    pageBottomBarOptions: {
                        ...options,
                        isShown: true,
                        hasInitialized,
                        hasBottomBarActive,
                    },
                });
            }
        };

        _closePageBottomBar = () => {
            this.setState(
                ({ pageBottomBarOptions: prevPageBottomBarOptions = {} }) => ({
                    pageBottomBarOptions: {
                        ...prevPageBottomBarOptions,
                        isShown: false,
                    },
                    hasInitialized: true,
                }),
            );
        };

        _initPageBottomBar = (hasBottomBarActive = false) => {
            this.setState(
                ({ pageBottomBarOptions: prevPageBottomBarOptions = {} }) => ({
                    pageBottomBarOptions: {
                        ...prevPageBottomBarOptions,
                        hasInitialized: true,
                        hasBottomBarActive,
                    },
                    hasBottomBarActive,
                    hasInitialized: true,
                }),
            );
        };

        render() {
            const { pageBottomBarOptions } = this.state;

            return (
                <div className="page-fixed-bottom-bar-layout-wrapper">
                    <div className="page-fixed-bottom-bar-layout__content">
                        <PageComponent
                            showPageBottomBar={this._showPageBottomBar}
                            closePageBottomBar={this._closePageBottomBar}
                            initPageBottomBar={this._initPageBottomBar}
                            {...this.props}
                        />
                    </div>
                    <PageBottomBar {...pageBottomBarOptions} />
                </div>
            );
        }
    };

export default withPageBottomBarControl;
